import { useMemo, useState } from 'react'

export const useErrors = () => {
  const [errors, setErrors] = useState<readonly { message: string }[]>([])
  const errorMessages = useMemo(() => errors.map(({ message }) => message), [errors])

  return {
    errors,
    errorMessages,
    setErrors,
  }
}
